export default __webpack_public_path__ + "static/media/003-pets.fa078d0c.png";